import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import auth from "./authreducer";

//shoot
import interviewees from "./shoot/intervieweesreducers";
import languages from "./shoot/languagesreducers";
import participants from "./shoot/participantsreducers";
import photoshots from "./shoot/photoshotsreducers";
import services from "./shoot/servicesreducers";
import videoshots from "./shoot/videoshotsreducers";
import shoot from "./shootreducers";
import selectedshoot from "./shoot/selectedshootreducer";

export default history => {
  return combineReducers({
    auth,
    router: connectRouter(history),
    interviewees,
    languages,
    participants,
    photoshots,
    services,
    videoshots,
    shoot,
    selectedshoot
  });
};
